import { registerPlugin } from '@capacitor/core';
const ScrollbarHider = registerPlugin('ScrollbarHider', {
    web: () => import('./web').then((m) => new m.ScrollbarHiderWeb()),
});
export * from './definitions';
export { ScrollbarHider };
//# sourceMappingURL=index.js.map